import React from "react";
import { FormBuilder, FormControl, Validators } from "react-reactive-form";
import LoginSignUpBanner from "../../components/ReusableComponents/LoginSignUpBanner/LoginSignUpBanner";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import {
  gender,
  height,
  weight,
} from "../../containers/SignUpSteps/UserDetails/UserDetails";
import { gymInfo, linkGym, updateProfile } from "../../services/CallApi";
import {
  checkCm_Feet,
  checkFT_value,
  checkKg_Pound,
  getData,
  height_weight_subscriber,
  imageForm,
  touched,
} from "../../services/CommonFormFunction";
import { CheckValue } from "../../services/CommonFunction";
import { pattern } from "../../services/subscriberService";
import store from "../../store";
import { getWhiteLabelData } from "../../services/Constants";

const SignUpHoc = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      const { profile } = props;
      const genderValue = gender.filter((el) => el.value === profile.gender);
      let weight_unit = weight.filter((el) => el.value === profile.weight_unit);
      if (!weight_unit.length) {
        weight_unit = weight[0];
      }
      let height_unit = height.filter((el) => el.value === profile.height_unit);
      if (!height_unit.length) {
        height_unit = height[0];
      }
      this.signUpForm = FormBuilder.group({
        userDetail: FormBuilder.group({
          profile_pic: FormBuilder.group(
            imageForm({ ...profile, keyValue: "thumb" })
          ),
          first_name: [
            profile.first_name || "",
            [
              Validators.required,
              Validators.minLength(2),
              Validators.maxLength(50),
            ],
          ],
          last_name: [
            profile.last_name || "",
            [
              Validators.required,
              Validators.minLength(2),
              Validators.maxLength(50),
            ],
          ],
          email: [
            { value: profile.email || "", disabled: true },
            [Validators.required, Validators.pattern(pattern.username)],
          ],
          dob: [
            profile.dob ? new Date(profile.dob) : null,
            Validators.required,
          ],
          gender: [genderValue.length ? genderValue : [], Validators.required],
          height_value: new FormControl(
            checkCm_Feet(
              height_unit.value,
              profile.height_value || null,
              height_unit.value === "CMs"
            ),
            {
              validators: Validators.required,
            }
          ),
          // height_value: [profile.height_value || null, [Validators.required]],
          height_unit: [height_unit],
          weight_value: new FormControl(
            checkKg_Pound(
              weight_unit.value,
              profile.weight_value || null,
              weight_unit.value === "Kg"
            ),
            {
              validators: Validators.required,
            }
          ),
          // weight_value: [profile.weight_value || null, [Validators.required]],
          weight_unit: [weight_unit],
          verifyEmail: [false],
        }),
        membership_code: [
          "",
          [Validators.required, Validators.pattern(pattern.memberShip)],
        ],
        location: [[], [Validators.required]],
      });
      this.state = {
        userDetails: {
          heading: null,
          subHeading1: "Tell us about yourself.",
          subHeading2: null,
          subHeading3: "Fill up the below form and tell us about you.",
          isLogoRequired: false,
        },
        verifyEmail: {
          heading: "Welcome Back",
          subHeading1: "Join the best digital fitness",
          subHeading2: "experience now!",
          isLogoRequired: true,
        },
        joinStudio: {
          heading: null,
          subHeading1: "Join your gym or fitness studio",
          subHeading2: null,
          subHeading3: "Enter your membership code and join now",
          isLogoRequired: true,
        },
        waiver: {
          heading: "Disclaimer",
          subHeading1: null,
          subHeading2: null,
          subHeading3: null,
          isLogoRequired: true,
        },
      };
    }
    get userDetailForm() {
      return this.signUpForm.get("userDetail");
    }

    componentDidMount() {
      height_weight_subscriber("subscribe", this.userDetailForm);
    }

    componentWillUnmount() {
      height_weight_subscriber("unsubscribe", this.userDetailForm);
    }

    submitData = (status = null) => {
      const formData = new FormData();
      const formValue = this.signUpForm.getRawValue().userDetail;
      const { profile, updateProfileData } = this.props;
      const { isWhiteLabeled } = getWhiteLabelData();

      if (profile.currentStatus === "joinStudio") {
        if (status === "skip") {
          formData.append("has_skipped_membership_code", true);
        } else if (status === "memberShip") {
          const data = {
            membership_code: this.signUpForm.value.membership_code,
            selected_location_ids: getData(
              this.signUpForm.value.location,
              "value",
              false
            ),
          };
          linkGym(data).then((response) => {
            updateProfileData(response.data);
          });
          return;
        }
      } else if (profile.currentStatus === "userDetails") {
        if (isWhiteLabeled) {
          formData.append("has_skipped_membership_code", true);
        }
        formData.append("email", formValue.email);
        formData.append("first_name", formValue.first_name);
        formData.append("last_name", formValue.last_name);
        formData.append(
          "height_value",
          checkCm_Feet(
            "CMs",
            formValue.height_value,
            getData(formValue.height_unit) === "CMs"
          )
        );
        formData.append("height_unit", getData(formValue.height_unit));
        formData.append(
          "weight_value",
          checkKg_Pound(
            "Kg",
            formValue.weight_value,
            getData(formValue.weight_unit) === "Kg"
          ) * 1000
        );
        formData.append("weight_unit", getData(formValue.weight_unit));
        formData.append("dob", new Date(formValue.dob).toISOString());
        formData.append("gender", getData(formValue.gender));
        formData.append("profile_pic", formValue.profile_pic.value);
      } else if (profile.currentStatus === "verifyEmail") {
        formData.append("email", formValue.email);
      }
      updateProfile(formData).then((response) => {
        if (response.status) {
          updateProfileData(response.data);
        } else {
          ErrorUI(response.list);
        }
      });
    };

    render() {
      const { currentStatus } = this.props.profile;

      return (
        <LoginSignUpBanner {...this.state[currentStatus]}>
          <WrappedComponent
            signUpForm={this.signUpForm}
            submitData={this.submitData}
            status={currentStatus}
            {...this.props}
          />
        </LoginSignUpBanner>
      );
    }
  };
};

export default SignUpHoc;
